import type { z } from "@hono/zod-openapi";
import { maybeOnVehicleRefs, onDriverRefs } from "../../refs";

/**
 * The submitting driver, and the unit when the form carries one.
 *
 * A driver submits every form, so the membership is required; the unit is a field on the form and some forms have no
 * place to put one.
 */
export const formSubmissionRefs = { ...onDriverRefs, ...maybeOnVehicleRefs };

export type FormSubmissionRefs = z.infer<z.ZodObject<typeof formSubmissionRefs>>;
